import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import '@angular/compiler'; // Ensure JIT compiler is available

import { AppModule } from './app/app.module';

//https://timdeschryver.dev/blog/angular-build-once-deploy-to-multiple-environments#platformbrowserdynamic
import { InitFileModel, APP_CONFIG } from './app/models/common/init-file.model';

import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';

fetch('/appsettings.json')
	.then((response) => response.json())
	.then((config: InitFileModel) => {
		// check override to allow access to webservices from other testing environments
		// in the local env (e.g. test without installing BE on local machine).
		if (!!environment.appsettings) {
			config = environment.appsettings as InitFileModel;
		}

		localStorage.setItem('EIF_ENVIRONMENT', JSON.stringify(config.startupApiEnvironment));

		if (config.production) {
			enableProdMode();

			if (location.protocol === 'http:') {
				window.location.href = location.href.replace('http', 'https');
			}
		}

		platformBrowser([{ provide: APP_CONFIG, useValue: config }])
			.bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
			.catch((err) => console.error(err));
	});
